export default __webpack_public_path__ + "static/media/classic.8bd5ce13.jpg";